<template>
	<div id="PostEditorImporter">
		<Loading v-if="loading" />
		<div class="container-fluid">
			<header>
				<div>
					<i class="fas fa-chevron-left" @click="back"></i>
				</div>
			</header>
			<div class="step" v-if="step == 1">
				<div class="row m-0">
					<div class="col-10 text-left">
						<h4>Importar posts</h4>
					</div>
					<div class="col-2">
						<span class="float-right" @click="step = 6">
							<img src="../../assets/img/icons/feather-settings@2x.png" alt />
						</span>
					</div>
					<div class="col-12">
						<p
							class="subtitle"
						>Até 10 posts podem ser imoprtados por vez do Wix, Wordpress e alguns outros similares.</p>
					</div>
					<div class="col-12 item--link my-2 fields" v-for="(link, index) in listLinks" :key="index">
						<input type="text" :id="'firstName-'+index" placeholder="First Name" v-model="link.url" />
						<label :for="'firstName-'+index">Link do post {{index + 1}}</label>
					</div>
					<div class="col-auto add--link my-4" v-if="alertLimit == false">
						<i class="fas fa-plus-circle" @click="addNewLink"></i>
					</div>
				</div>
				<div class="row" v-if="alertLimit == true">
					<div
						class="col-12 text--alert--limit text-left"
					>Você pode importar no máximo 10 posts por vez. Clique em Continuar para importar esses e volte para importar mais depois.</div>
				</div>
				<div class="div--botao">
					<button
						class="btn btn-primario btn--next"
						v-if="validateStep1"
						@click="sendLinksToImporter"
					>Continuar</button>
				</div>
			</div>
			<div class="step" v-if="step == 2">
				<div class="row m-0">
					<div class="col-10 text-left">
						<h4>Qual o título correto do post?</h4>
					</div>
					<div class="col-2">
						<span class="float-right" @click="step = 6">
							<img src="../../assets/img/icons/feather-settings@2x.png" alt />
						</span>
					</div>
					<div class="col-12 list--titles mt-4">
						<span @click="step = 3">CABINDA E O TESOURO ANGOLANO</span>
						<span>MALAVIAJANTE TRAVEL THE COUNTRIES</span>
						<span>9 de Ago de 2019 2 minutos para ler</span>
						<span>Angola é um desses lugares no mundo que traz...</span>
					</div>
				</div>
			</div>
			<div class="step" v-if="step == 3">
				<div class="row m-0">
					<div class="col-10 text-left">
						<h4>Qual o conteúdo correto do post?</h4>
					</div>
					<div class="col-12 list--titles mt-4">
						<span>CABINDA E O TESOURO ANGOLANO</span>
						<span>MALAVIAJANTE TRAVEL THE COUNTRIES</span>
						<span>9 de Ago de 2019 2 minutos para ler</span>
						<span>Angola é um desses lugares no mundo que traz...</span>
					</div>
				</div>
			</div>
			<div class="step" v-if="step == 6">
				<div class="row m-0 text-left">
					<div class="col-12">
						<h4>Avançado</h4>
						<p
							class="subtitle"
						>Copie e cole o código html do post ou entre em contato com nossa equipe para ajuda: 17 3223 5208</p>
					</div>
					<div class="col-12 my-2 fields">
						<input
							type="text"
							id="advancedTitle"
							placeholder="First Name"
							v-model="advancedContent.title"
						/>
						<label for="advancedTitle">Html do Título</label>
					</div>
					<div class="col-12 my-2">
						<textarea
							class="field"
							id="advancedBody"
							placeholder="HTML do conteúdo"
							rows="10"
							cols="40"
							v-model="advancedContent.body"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import Loading from "@/components/Loading";

export default {
	name: "PostEditorImporter",
	data() {
		return {
			loading: false,
			step: 1,
			alertLimit: false,
			siteId: null,
			listLinks: [
				{
					url: "",
				},
			],
			advancedContent: {
				title: "",
				body: "",
			},
		};
	},
	components: {
		Loading,
	},
	methods: {
		addNewLink,
		sendLinksToImporter,
		back,
	},
	created() {
		this.siteId = this.$session.get("siteId");
	},
	computed: {
		validateStep1() {
			let validate = this.listLinks.some((link) => link.url != "");
			return validate;
		},
	},
};
function back() {
	if (this.step > 1) {
		this.step--;
	} else {
		this.$router.push("/dashboard");
	}
}
function addNewLink() {
	if (this.listLinks.length < 10) {
		this.listLinks.push({
			url: "",
		});
	} else {
		this.alertLimit = true;
	}
	setTimeout(() => {
		document.documentElement.scrollTop =
			document.getElementById("PostEditorImporter").offsetHeight -
			window.innerHeight;
	}, 300);
}
function sendLinksToImporter() {
	this.loading = true;
	let token = this.$session.get("jwt");
	axios({
		method: "post",
		url: `${process.env.ROOT_API}/api/site/${this.siteId}/import`,
		data: { links: this.listLinks },
		headers: {
			Authorization: "Bearer " + token,
			"Content-Type": "application/json",
		},
	}).then((response) => {
		this.loading = false;
		if (response.data.status == 1) {
			alert(
				`Importados: ${response.data.ok}. Falhos: ${response.data.fail}`
			);
			window.localStorage.removeItem("activeCategory");
			window.localStorage.removeItem("activeCategoryRoute");
			this.$router.push("/dashboard");
		}
	});
}
</script>

<style scoped>
header {
	display: flex;
	align-items: center;
	height: 80px;
	padding: 15px;
}
header div {
	display: block;
}
i {
	color: var(--main-color);
	cursor: pointer;
}
.step h4 {
	font-family: "Montserrat", sans-serif;
	font-weight: bolder;
	color: #000;
	font-size: 25px;
	line-height: 1.8rem;
}
.step .subtitle,
.step .text--alert--limit {
	font-size: 11px;
	font-family: "Open Sans", sans-serif;
	color: #7f7f7f;
}
.add--link i {
	font-size: 21px;
}
.item--link {
	text-align: left;
}
.item--link label {
	display: block;
}
.item--link input[type="text"] {
	width: 100%;
}
.step .text--alert--limit {
	margin-bottom: 80px;
}
.step .div--botao {
	position: fixed;
	bottom: 0;
	left: calc(50% - 70px);
	padding: 15px 0;
}
.step .div--botao button {
	width: 140px;
	height: 50px;
}
.list--titles {
	text-align: left;
}
.list--titles span {
	display: inline-block;
	padding: 5px 10px;
	margin: 2px 0;
	background: #f8f8f8;
	border-radius: 60px;
	height: 32px;
	font-size: 13px;
	font-family: "Open Sans", sans-serif;
	color: #a8a8a8;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

input {
	outline: none;
	border: none;
}
.fields {
	width: 100%;
	height: auto;
	display: inline-block;
	position: relative;
	margin-bottom: 20px;
}
.fields label {
	position: absolute;
	top: 0;
	left: 15px;
	cursor: text;
	color: #9e9e9e;
	transform: translateY(18px);
	transition: transform 0.25s ease-in-out;
	transform-origin: 0% 100%;
}
.fields input {
	width: 100%;
	height: 46px;
	border: 0px;
	border-bottom: 1px solid #e3e3e3;
	transition: border-bottom, box-shadow 0.4s ease-in-out;
}
.fields input::before {
	content: "";
	display: block;
	position: absolute;
	bottom: 0px;
	left: 0;
	width: 0;
	height: 2px;

	-webkit-transition: all 0.4s;
	-o-transition: all 0.4s;
	-moz-transition: all 0.4s;
	transition: all 0.4s;

	background: #6828e8;
}
.fields input:focus + .fields label::before {
	width: 100%;
}
.fields input:focus {
	border-bottom: 1px solid #6828e8;
	outline: 1px solid transparent;
}
.fields input:focus + label {
	transform: translateY(-14px) scale(0.8);
}
.fields input::-webkit-input-placeholder,
.fields input::-moz-input-placeholder {
	color: transparent;
}
.fields input::placeholder {
	color: transparent;
}
.fields input:not(:placeholder-shown) {
	border-bottom: 1px solid #e3e3e3;
}
.fields input:not(:placeholder-shown) + label {
	transform: translateY(-14px) scale(0.8);
}
</style>


// WEBPACK FOOTER //
// src/components/templates/PostEditorImporter.vue